import { useRoute } from 'vue-router';

import { hasBaseCarrierWorkplaceSubscription, hasCarrierWorkplaceSubscription } from '@/domains/permissions/subscription';
import { ROUTE_TYPE } from '@/constants';
import { useTenantsStore } from '@/stores/tenants';
import { hasInstanceLicense } from '@/domains/hasInstanceLicense';

export const getIsBillingSpecialOfferNoticeGlobalShown = () => {
  const route = useRoute();
  const tenantsStore = useTenantsStore();

  const isPrivateRoute = route?.meta?.type === ROUTE_TYPE.private;
  const hasTenants = !!tenantsStore.userTenants?.length;

  const activeSubscription = tenantsStore.getActiveSubscription;

  return isPrivateRoute
  && !hasInstanceLicense()
  && hasTenants
  && (hasCarrierWorkplaceSubscription() || hasBaseCarrierWorkplaceSubscription())
  && !!activeSubscription?.specialOffer
  && !activeSubscription.specialOffer.confirmedAt;
};
